<template>
  <div id="ProjectHeading">
    <v-skeleton-loader
      v-if="loading"
      type="text"
    />
    <v-toolbar v-else>
      <v-toolbar-title>
        <v-icon left>{{ project.icon}}</v-icon>
        {{ project.name }}
      </v-toolbar-title>
      <v-spacer />
      <ProjectForm :instance="project" :is-edit="true">
        <template v-slot:button="{ on }">
          <v-btn outlined rounded v-on="on" class="mx-1" color="primary">
            <v-icon left>edit</v-icon>
            Edit
          </v-btn>
        </template>
        <template #title>Edit {{ project.forgeID}}</template>
      </ProjectForm>
      <ProjectArchiveButton :project="project" />
      <template v-slot:extension>
        <span class="body-1 mx-3">
          Project ID: <b>{{ project.forgeID }}</b>
        </span>
        <span class="body-1 mx-3">
          <v-icon small class="mr-1">fas fa-cubes</v-icon>
          <b>{{ project.children.length }}</b> Work Orders
        </span>
        <span class="body-1 mx-3">
          <v-icon small class="mr-1">fas fa-cube</v-icon>
          <b>{{ batchCount }}</b> Batches
        </span>
        <span class="body-1 mx-3" v-if="!project.archived">
          <v-icon
            small
            class="mr-1"
            :color="project.getDaysTill().colorBase"
          >
            mdi-timetable
          </v-icon>
          <b>{{ project.getDaysTill().days }}</b> Days Left
        </span>
        <v-spacer />
        <v-chip color="primary">{{ project.company.name }}</v-chip>
        <v-tooltip v-if="project.commercial" bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mx-2" v-on="on" color="purple darken-2">mdi-factory</v-icon>
          </template>
          <span>Commercial</span>
        </v-tooltip>
        <v-tooltip v-if="project.invoiceable" bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mx-2" v-on="on" color="green darken-2">mdi-currency-usd</v-icon>
          </template>
          <span>Invoicing</span>
        </v-tooltip>
        <v-tooltip v-if="project.grant" bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="mx-2" v-on="on" color="red darken-2">mdi-school</v-icon>
          </template>
          <span>Grant Work</span>
        </v-tooltip>
      </template>
    </v-toolbar>
  </div>
</template>

<script>
import Project from "../../models/Project";
import Batch from "../../models/Batch";
import ProjectForm from "./ProjectForm";
import ProjectArchiveButton from "./ProjectArchiveButton";
export default {
  name: "ProjectHeading",
  components: { ProjectArchiveButton, ProjectForm },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    project() {
      return Project.query().with("children").with("company").find(parseInt(this.id))
    },
    batchCount() {
      return Batch.batchCount(parseInt(this.id))
    }
  }
}
</script>
